import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const ValuesGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;

  @media (max-width: ${screenSizes.mobile}) {
    gap: 1.5rem;
  }
`;

export const ValueCardStyled = styled.div`
  display: grid;
  grid-template-columns: 20% 1fr;
  gap: 1.5rem;
  align-items: center;
  padding: 1rem 0;

  &.value-item-odd {
    grid-template-columns: 1fr 20%;

    .value-visual {
      order: 2;
    }

    .value-content {
      order: 1;
      text-align: right;
    }

    .value-title {
      flex-direction: row-reverse;
    }

    .value-accent-line {
      margin-left: auto;
    }

    @media (max-width: ${screenSizes.mobile}) {
      grid-template-columns: 1fr;

      .value-visual {
        order: 1;
      }

      .value-content {
        order: 2;
        text-align: left;
      }

      .value-accent-line {
        margin-left: 0;
      }
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0.75rem 0;
  }

  .value-visual {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .value-image-wrapper {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 0.5rem;
    overflow: hidden;

    @media (max-width: ${screenSizes.mobile}) {
      display: none;
    }
  }

  .value-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .value-content {
    padding: 0.5rem 0;
  }

  .value-header {
    margin-bottom: 0.75rem;
  }

  .value-title {
    font-size: 1.75rem;
    font-weight: 800;
    margin: 0 0 0.5rem 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.2;

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 1.5rem;
    }
  }

  .value-accent-line {
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    border-radius: 2px;
    margin-top: 0.25rem;
    transition: width 0.4s ease;
  }

  .value-item:hover .value-accent-line {
    width: 90px;
  }

  .value-description {
    color: #475569;
    line-height: 1.6;
    margin: 0;
    font-size: 0.9rem;
    font-weight: 400;
    opacity: 0.9;
    transition: opacity 0.3s ease;

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 0.85rem;
      line-height: 1.5;
    }
  }

  .value-item:hover .value-description {
    opacity: 1;
  }
`;
